import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  downloadGradesBtn: {
    id: 'gradebook.GradesView.BulkManagementControls.bulkManagementLabel',
    defaultMessage: 'Download Grades',
    description: 'A labeled button that allows an admin user to download course grades all at once (in bulk).',
  },
});

export default messages;
